import React from "react";
import PropTypes from "prop-types";

function Item({ item, showUsersModal }) {
  return (
    <div className="container_result_statistic_number row">
      <p className="col s3">{item.webinar_title}</p>
      <p className="col s2">
        <span
          className={
            item.attended_count != 0 && showUsersModal ? "link-style" : ""
          }
        >
          {item.attended_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={
            item.views_count != 0 && showUsersModal ? "link-style" : ""
          }
        >
          {item.views_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={
            item.downloads_count != 0 && showUsersModal ? "link-style" : ""
          }
        >
          {item.downloads_count}
        </span>
      </p>
      <p className="col s2">
        <span
          className={
            item.completed_counts != 0 && showUsersModal ? "link-style" : ""
          }
        >
          {item.completed_counts}
        </span>
      </p>
      <p className="col s2">
        <span
          className={
            item.in_person_count != 0 && showUsersModal ? "link-style" : ""
          }
        >
          {item.in_person_count}
        </span>
      </p>
    </div>
  );
}

Item.defaultProps = {};

Item.propTypes = {};

export default Item;



// WEBPACK FOOTER //
// ./src/containers/HostDashboard/Item.jsx